import { render } from "./StartAnimation.vue?vue&type=template&id=03518950"
import script from "./StartAnimation.vue?vue&type=script&lang=js"
export * from "./StartAnimation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\kiemp\\OneDrive\\Documents\\VSCode\\SMM2_info\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__